module.exports = __webpack_public_path__ + "img/msis.db0ac471.svg";